module.exports = __webpack_public_path__ + "img/PencilSimpleLine.01194002.svg";